export function RestApiIcon({ className }: { className?: string }) {
    return (
      <svg
        className={className}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 2a2 2 0 112 2h3a2 2 0 110 4h-3a2 2 0 11-2-2 2 2 0 110-4zM5 9a2 2 0 100 4h3a2 2 0 100-4H5zm11 2a2 2 0 112 2h3a2 2 0 110 4h-3a2 2 0 11-2-2 2 2 0 110-4zM10 15a2 2 0 100 4h3a2 2 0 100-4h-3z" />
      </svg>
    );
  }
  